import React from 'react';
import { connect, ResolveThunks } from 'react-redux';
import RedoIcon from '@mui/icons-material/Redo';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { redoLastAnnotationChange } from '../../actions/annotations';

type DispatchProps = ResolveThunks<typeof actionCreators>;
type Props = DispatchProps;

function RedoButton(props: Props) {
  return (
    <Tooltip disableInteractive disableFocusListener id="reset-page-tooltip" title="Redo">
      <div>
        <IconButton sx={{ borderRadius: 0, width: '100%' }} aria-label="Redo" onClick={props.redoLastAnnotationChange}>
          <RedoIcon />
        </IconButton>
      </div>
    </Tooltip>
  );
}

const actionCreators = {
  redoLastAnnotationChange,
};

export default connect(null, actionCreators)(RedoButton);
